/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/invoices",
    },
    (router) => {
      router.push({
        id: "@api/invoice@search",
        path: "",
      });

      router.group({ path: "/:invoiceId" }, (router) => {
        router.push({
          id: "@api/invoice@show",
          path: "",
        });

        router.group(
          {
            path: "/downloads",
          },
          (router) => {
            router.push({
              id: "@api/invoice@download-invoice",
              path: "/invoice",
            });

            router.push({
              id: "@api/invoice@download-quotation",
              path: "/quotation",
            });
          },
        );
      });

      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api/invoice@revive",
            path: "/revive",
          });
        },
      );
    },
  );
}
